import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import ListItem from '@material-ui/core/ListItem';
import { mediaPatterns, getThumbnailUrl } from 'utils/mediaPatterns';

const styles = theme => ({
  imgPreviewContainer: {
    position: 'relative',
    display: 'inline-block',
  },
  imgPreview: {
    maxHeight: "450px",
    maxWidth: "100%",
    display: 'block',
  },
  playButton: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    fontSize: '48px',
    color: 'white',
    textShadow: '2px 2px 4px rgba(0,0,0,0.8)',
    pointerEvents: 'none',
    zIndex: 1,
  },
  listNested: {
    fontSize: theme.typography.pxToRem(14),
    paddingLeft: '0px',
    paddingRight: '0px',
    overflowWrap: 'break-word',
    wordWrap: 'break-word',
    msWordBreak: 'break-all',
    wordBreak: 'break-all',
    whiteSpace: 'pre-wrap',
  },
});

const MediaPreview = ({ text, classes }) => {
  const allMatches = Object.values(mediaPatterns)
    .map(pattern => text.match(pattern) || [])
    .flat()
    .filter(Boolean);

  if (allMatches.length === 0) {
    return null;
  }

  return allMatches.map((link) => {
    const destLink = getThumbnailUrl(link);
    const isVideo = link.includes('youtube.com') || link.includes('youtu.be');

    return (
      <ListItem className={classes.listNested} key={destLink}>
        <a href={link} target="_blank" rel="noopener noreferrer" className={classes.imgPreviewContainer}>
          <img 
            className={classes.imgPreview} 
            src={destLink} 
            alt={isVideo ? 'Video thumbnail' : 'Image preview'}
            onError={(e) => {
              e.target.style.display = 'none';
              console.warn('Failed to load preview:', destLink);
            }}
          />
          {isVideo && (
            <div className={classes.playButton}>▶</div>
          )}
        </a>
      </ListItem>
    );
  });
};

MediaPreview.propTypes = {
  text: PropTypes.string.isRequired,
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(MediaPreview);